/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGlobalSearch, useProcess } from "@/global-data";
import { useDeletePopup } from "@/global-data/use-delete-popup";
import { useDebouncedValue } from "@/hooks/use-debounced-value";
import { useToast } from "@/hooks/use-toast";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import { user_activity } from "@/services/global.services";
import { useEffect, useMemo, useState } from "react";
import { DateObject } from "react-multi-date-picker";

export const useMutations = () => {
  const API_SERVICE = user_activity;
  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const { setProcess } = useProcess();
  const [skeltonLoading, setSkeltonLoading] = useState(true);
  const [listData, setListData] = useState([]);
  const [companyData, _setCompanyData] = useState([]);
  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [activeRecordData, setActiveRecordData] = useState<any>(undefined);
  const [tableColumn, setTableColumn] = useState([]);

  const { setSearchProgress, search } = useGlobalSearch();
  const { toast } = useToast();
  const [searchDebounced] = useDebouncedValue(search, 200);
  const [deleteId, setDeleteId] = useState(undefined);
  const [filter, setFilter] = useState({});

  const [dateFilter, setDateFilter] = useState();

  const { onDelete, status, identity, clearDelete } = useDeletePopup();

  const [paginationData, setPaginationData] = useState({
    page: 1,
    perPage: 10,
    totalItem: 1,
  });

  //On Load Component
  useEffect(() => {
    const end = new DateObject().format("DD-MM-YYYY");
    const start = new DateObject().subtract(29, "days").format("DD-MM-YYYY");
    const dateFilterData = [start, end];
    (async () => {
      await loadingList({ searchText: "", dateFilterData });
      await wait(1000);
      setSkeltonLoading(false);
      setProcess(false);
    })();
  }, []);

  //handle delete
  useEffect(() => {
    if (status === "cancel") {
      setDeleteId(undefined);
      clearDelete();
    }
    if (status === "delete" && identity === "user") {
      (async () => {
        setProcess(true);
        const deleteResponse = await deleteRecord();
        if (deleteResponse.data) {
          await loadingList({});
        }
        clearDelete();
        setDeleteId(undefined);
        setProcess(false);
      })();
    }
  }, [status]);

  const deleteRecord = async () => {
    const payload = {
      data: {
        uom: deleteId,
        company_id: company_id,
      },
      company_id: company_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_SERVICE.delete,
      "post",
      payload
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    return { data, error };
  };

  //Handle Search
  useEffect(() => {
    if (skeltonLoading === false) {
      (async () => {
        setSearchProgress(true);
        await loadingList({});
        setSearchProgress(false);
      })();
    }
  }, [searchDebounced]);

  const onFormOpenChange = (prop: boolean) => {
    setFormPopupOpen(prop);
  };

  const onPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, page: prop }));
    setProcess(true);
    await loadingList({ page: prop });
    setProcess(false);
  };
  const onPerPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
    setProcess(true);
    await loadingList({ perPage: prop, page: 1 });
    setProcess(false);
  };

  const permission: any = [];
  const onAction = async ({ action, data }: any) => {
    if (action === "edit") {
      setActiveRecordData(data);
      onFormOpenChange(true);
    }
    if (action === "delete") {
      setActiveRecordData(data);
      setDeleteId(data.uom);
      onDelete({
        description:
          "This action cannot be undone. This will permanently delete the record and remove its data from our system.",
        id: data.user_id,
        identity: "user",
        popupStatus: true,
        title: "Are you sure you want to delete this user activity?",
      });
      await loadingList({});
    }
  };

  useEffect(() => {
    if (formPopupOpen === false) {
      setActiveRecordData(undefined);
    }
  }, [formPopupOpen]);

  const loadingList = async ({
    perPage,
    page,
    filterReset,
    makeFilter,
    searchText,
    dateFilterData,
  }: {
    perPage?: number;
    page?: number;
    filterReset?: boolean;
    makeFilter?: boolean;
    searchText?: string;
    dateFilterData?: any;
  }) => {
    let apiFilter = {};

    if (!filterReset) {
      apiFilter = filter;
    }

    let page_no = page || paginationData.page;

    if (makeFilter) {
      page_no = 1;
    }

    const payload = {
      data: {
        // username: userData?.username,
        filter_by: {
          ...apiFilter,
          search_text: searchText ?? searchDebounced,
          date_range: dateFilterData || dateFilter,
          exact_match: false,
          pagination: {
            page_no: page_no,
            no_of_recs: perPage || paginationData.perPage,
            sort_by: "cts",
            order_by: false,
          },
        },
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message /* error, message, statusCode */ } =
      await apiServices<any>(API_SERVICE.get, "post", payload);

    if (data) {
      const listData = data.result.metadata?.[API_SERVICE.key];
      setListData(listData);

      setPaginationData((prev) => ({
        ...prev,
        totalItem: data?.result?.metadata?.total_records || 1,
      }));
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    return { data, error };
  };

  const onFormSubmit = async (prop: any): Promise<any> => {
    let formData = {};

    if (activeRecordData) {
      formData = {
        name: prop.name,
        workflow_id: activeRecordData.workflow_id,
        description: prop.description,
        synonym_mapping: prop.synonym_mapping,
      };
    } else {
      formData = {
        is_new: true,
        name: prop.name,
        description: prop.description,
        synonym_mapping: prop.synonym_mapping,
      };
    }

    const payload = {
      data: formData,
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_SERVICE.post,
      "post",
      payload
    );

    if (data) {
      await loadingList({});
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    setProcess(false);

    return { data, error };
  };

  const filterRequest = async () => {
    setProcess(true);
    await loadingList({ makeFilter: true });
    setProcess(false);
  };
  const clearFilter = async () => {
    setFilter({});
    setProcess(true);
    await loadingList({ filterReset: true });
    setProcess(false);
  };

  const onDateChange = async (prop: any) => {
    setDateFilter(prop);
    setProcess(true);
    await loadingList({ dateFilterData: prop, page: 1 });
    setProcess(false);
  };

  return {
    skeltonLoading,
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    activeRecordData,
    onFormSubmit,
    onFormOpenChange,
    formPopupOpen,
    tableColumn,
    setTableColumn,
    companyData,
    filter,
    setFilter,
    filterRequest,
    clearFilter,
    onDateChange,
  };
};
